import { createTRPCReact, httpBatchLink, type CreateTRPCReact } from '@trpc/react-query';
import { createTRPCClient, httpLink, TRPCClientError, type TRPCLink } from '@trpc/client';
import type { AppRouter } from '@tg/api';
import superjson from 'superjson';
import { getSession, setSession } from './session';

export const trpc: CreateTRPCReact<AppRouter, unknown> = createTRPCReact<AppRouter>();

export const API_URL: string = ((import.meta as any).env?.VITE_API_URL || 'http://localhost:3000').replace(/\/$/, '');
/** Абсолютный адрес медиа API (превью упражнений лежат на API) */
export const mediaUrl = (u: string | null | undefined) => (!u ? '' : /^https?:/.test(u) ? u : API_URL + u);

/* Рефреш токена: один на всех одновременных запросах */
let refreshing: Promise<boolean> | null = null;
const raw = createTRPCClient<AppRouter>({ links: [httpLink({ url: API_URL + '/trpc', transformer: superjson })] });
async function refresh(): Promise<boolean> {
  const s = getSession();
  if (!s) return false;
  refreshing ||= raw.auth.refresh
    .mutate({ token: s.refresh })
    .then((r) => {
      setSession({ access: r.access, refresh: r.refresh, role: r.role, pid: r.pid });
      return true;
    })
    .catch((e) => {
      /* Нет сети — сессию не трогаем (оффлайн живёт со старым токеном); 401 — выходим */
      if (e instanceof TRPCClientError && e.data?.code === 'UNAUTHORIZED') setSession(null);
      return false;
    })
    .finally(() => setTimeout(() => (refreshing = null), 0));
  return refreshing;
}

const authFetch: typeof fetch = async (input, init) => {
  const go = () => {
    const s = getSession();
    const headers = new Headers(init?.headers);
    if (s) headers.set('authorization', 'Bearer ' + s.access);
    return fetch(input, { ...init, headers });
  };
  let res = await go();
  if (res.status === 401 && getSession() && (await refresh())) res = await go();
  return res;
};

/** pre — свои звенья перед отправкой (оффлайн кабинета тренера: ответы без сети из данных на устройстве) */
export const makeTrpcClient = (pre: TRPCLink<AppRouter>[] = []) =>
  trpc.createClient({ links: [...pre, httpBatchLink({ url: API_URL + '/trpc', transformer: superjson, fetch: authFetch })] });

/** Клиент без React — для действий вне компонентов */
export const api = createTRPCClient<AppRouter>({ links: [httpBatchLink({ url: API_URL + '/trpc', transformer: superjson, fetch: authFetch })] });
